import React from "react";
import PropTypes from "prop-types";

import styles from "./dotsLoader.scss";

export default function DotsLoader({ text }) {
  return <span className={styles.dotsLoader}>
    {text} <span>.</span><span>.</span><span>.</span>
  </span>;
}

DotsLoader.defaultProps = {
  text: "Please Wait",
};

DotsLoader.propTypes = {
  text: PropTypes.string,
};
